import { render, staticRenderFns } from "./WritingEditor.vue?vue&type=template&id=34b2834a&scoped=true"
import script from "./WritingEditor.vue?vue&type=script&lang=js"
export * from "./WritingEditor.vue?vue&type=script&lang=js"
import style0 from "./WritingEditor.vue?vue&type=style&index=0&id=34b2834a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b2834a",
  null
  
)

export default component.exports